import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Atv from 'react-scale/components/ui/atv';
import Link from 'react-scale/components/ui/LinkIsNot';

const UseCase = ({ width, height, imgSrc, imgSrcFront, label, link, text, theme }) => (
  <div style={{ width }}>
    {link ? (
      <Link href={link}>
        <div className="relative w-full mb-10" style={{ paddingBottom: '72.25%' }}>
          <div className="absolute inset-0">
            <Atv
              layers={[imgSrc, imgSrcFront].filter(layer => layer !== undefined)}
              staticFallback="http://kloc.pm/images/kloc-icon-flattened.jpg"
              isStatic={false}
              style={{ width, height }}
            />
          </div>
        </div>
        <p className={cn(textTheme[theme], 'mb-4 text-xl')}>{label}</p>
        {text && <p>{text}</p>}
      </Link>
    ) : (
      <>
        <div className="relative w-full mb-10" style={{ paddingBottom: '72.25%' }}>
          <div className="absolute inset-0">
            <Atv
              layers={[imgSrc, imgSrcFront].filter(layer => layer !== undefined)}
              staticFallback="http://kloc.pm/images/kloc-icon-flattened.jpg"
              isStatic={false}
              style={{ width, height }}
            />
          </div>
        </div>
        <p className={cn(textTheme[theme], 'mb-4 text-xl')}>{label}</p>
        {text && <p className="mt-2 text-center text-gray-700 ">{text}</p>}
      </>
    )}
  </div>
);

UseCase.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.string
};

const textTheme = {
  dark: 'text-white',
  light: 'text-black'
};

UseCase.defaultProps = {
  width: '280px',
  height: '200px',
  theme: 'dark'
};

const UseCases = ({ children }) => (
  <div className="use-cases">
    {children}
    <style jsx>{`
      .use-cases {
        display: grid;
        justify-content: space-around;
        grid-template-columns: 100%;
      }
      @media only screen and (min-width: 768px) {
        .use-cases {
          display: grid;
          padding: 0 30px 30px 30px;
          grid-template-columns: 280px 280px;
          grid-row-gap: 80px;
        }
      }
      @media only screen and (min-width: 992px) {
        .use-cases {
          display: grid;
          padding: 0;
          grid-template-columns: 280px 280px 280px;
          justify-content: space-between;
        }
      }
    `}</style>
  </div>
);

export { UseCases, UseCase };
